<template>
  <div class="container clip-container">
    <div class="clip-header">
      <div
        :key="`label-${index}`"
        :class="`item pointer ${index === funcNum ? 'active' : ''}`"
        v-for="(item, index) in label"
        @click="chooseFunc(index)"
      >
        <i :class="`iconfont ${item.icon}`"></i>
        <span>{{ item.title }}</span>
      </div>
    </div>
    <div class="clip-content">
      <!-- 音频转换模块 -->
      <div class="change-music" v-if="funcNum === 0">
        <div class="change-music-header">
          <i class="iconfont icon-auto"></i>
          <span>在线转换音频文件</span>
        </div>
        <div class="change-music-content">
          <div class="change-music-content-target">
            <span>输出格式 :</span>
            <el-select v-model="target" placeholder="请选择">
              <el-option v-for="item in options" :key="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="change-music-content-file">
            <el-upload
              v-show="!changeMusicFileObj"
              drag
              :on-change="changeMusicFile"
              :auto-upload="false"
              action="#"
              class="upload"
              :limit="1"
              :accept="audioAcceptTypes"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传音频文件，且不超过50MB
              </div>
            </el-upload>
          </div>
          <div class="change-music-content-func">
            <el-button type="primary" @click="changeMusicTarget"
              >转换</el-button
            >
            <el-button @click="handleCancel">取消</el-button>
          </div>
        </div>
      </div>

      <!-- 音频截取模块 -->
      <div class="music-split" v-if="funcNum === 1">
        <div class="music-split-header">
          <i class="iconfont icon-jiequyinpin"></i>
          <span>音频文件截取</span>
        </div>
        <div class="music-split-content">
          <div class="music-split-content-file">
            <el-upload
              drag
              :on-change="splitMusicFile"
              :auto-upload="false"
              action="#"
              class="upload"
              :limit="1"
              :file-list="splitUploadFileList"
              v-show="splitUploadFileList.length === 0"
              :accept="audioAcceptTypes"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传音频文件，且不超过50MB
              </div>
            </el-upload>
            <AudioWaveComponent
              :audio-file="splitMusicAudio"
              v-show="splitUploadFileList.length !== 0"
              @reset="handleReset"
              @download="downloadSplitFile"
            />
          </div>
        </div>
      </div>

      <!-- 视频音乐提取模块 -->
      <div class="video-music" v-if="funcNum === 2">
        <div class="video-music-header">
          <i class="iconfont icon--_tiquduanmian"></i>
          <span>视频音乐提取</span>
        </div>
        <div class="video-music-content">
          <div class="video-music-content-file">
            <el-upload
              v-show="!extractVideoFile"
              drag
              :on-change="videoMusicFile"
              :auto-upload="false"
              action="#"
              class="upload"
              :limit="1"
              :file-list="splitUploadFileList"
              :accept="videoAcceptTypes"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传视频文件，且不超过50MB
              </div>
            </el-upload>
            <div v-if="extractVideoFile" class="video-preview-info">
              <p>已选择文件：{{ extractVideoFile.name }}</p>
              <div class="video-music-content-func">
                <el-button type="primary" @click="extractVideoMusic"
                  >提取</el-button
                >
                <el-button @click="handleReset">取消</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 音频转换进度条和下载按钮 -->
      <div
        class="upload-file-info"
        v-show="funcNum === 0 && uploadFileName !== ''"
      >
        <div>{{ uploadFileName }}</div>
        <el-progress
          :percentage="uploadFileChangeProgress"
          :status="uploadFileChangeProgress === 100 ? 'success' : undefined"
        ></el-progress>
        <el-button size="mini" @click="downloadConvertedFile">下载</el-button>
      </div>

      <!-- 视频音乐提取进度条 -->
      <div
        class="upload-file-info"
        v-show="funcNum === 2 && uploadFileName !== ''"
      >
        <div>{{ uploadFileName }}</div>
        <el-progress
          :percentage="uploadFileChangeProgress"
          :status="uploadFileChangeProgress === 100 ? 'success' : 'exception'"
        ></el-progress>
        <el-button size="mini" @click="downloadConvertedFile">下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL, downloadFile } from "../api";
import { changeMusic, splitMusic, extractVideoMusic, splitVideo } from "../api";
import AudioWaveComponent from "../components/AudioWaveComponent";

export default {
  name: "Clip",
  components: { AudioWaveComponent },
  data() {
    return {
      label: [
        { icon: "icon-auto", title: "音频转换" },
        { icon: "icon-jiequyinpin", title: "音频截取" },
        { icon: "icon--_tiquduanmian", title: "音频提取" },
      ],
      funcNum: 0,
      target: "",
      splitMusicAudio: {},
      options: ["mp3", "m4v", "avi", "mkv", "aiff/aifc", "wma", "flac", "mov"],
      clientId: "",
      videoSrc: null,
      sseConnection: null,
      splitUploadFileList: [],
      audioAcceptTypes:
        ".mp3,.wav,.flac,.aac,.m4a,.ogg,.wma,.ape,.opus,.amr,.m4r",
      videoAcceptTypes:
        ".mp4,.avi,.mov,.wmv,.flv,.mkv,.webm,.m4v,.3gp,.ts,.rm,.rmvb,.mpeg,.mpg",
      uploadFileName: "",
      uploadFileChangeProgress: 0,
      changeMusicFileObj: null,
      extractVideoFile: null,
      downloadUrl: "",
    };
  },
  methods: {
    chooseFunc(index) {
      this.funcNum = index;
      this.clear();
    },

    createSSE() {
      const sseUrl = `${API_BASE_URL}/sse/connect/?clientId=${this.clientId}`;
      this.sseConnection = new EventSource(sseUrl);

      this.sseConnection.onopen = () => {
        console.log("SSE连接已建立");
      };

      this.sseConnection.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("SSE消息:", data);
          if (data.type === "progress") {
            this.uploadFileChangeProgress = data.percentage;
          } else if (data.type === "success") {
            this.$message.success(data.message);
            if (data.filePath) {
              this.downloadUrl = data.filePath;
            } else if (data.downloadUrl) {
              this.downloadUrl = data.downloadUrl;
            } else if (data.outputPath) {
              this.downloadUrl = data.outputPath;
            }
          } else if (data.type === "error") {
            this.$message.error(data.message);
          }
        } catch (error) {
          console.error("解析SSE消息失败", error);
        }
      };

      this.sseConnection.onerror = (error) => {
        console.error("SSE连接错误:", error);
      };
    },

    changeMusicFile(event) {
      console.log(event);
      this.uploadFileName = event.name;
      this.changeMusicFileObj = event.raw;
    },

    async changeMusicTarget() {
      if (!this.changeMusicFileObj) {
        this.$message.warning("请先上传音频文件");
        return;
      }
      if (!this.target) {
        this.$message.warning("请选择目标格式");
        return;
      }
      try {
        const res = await changeMusic(
          this.changeMusicFileObj,
          this.target,
          this.clientId
        );
        this.$message.success(res.data.message || "转换任务已提交");
        this.uploadFileChangeProgress = 0;
      } catch (error) {
        console.error("转换请求失败", error);
        this.$message.error("转换请求失败");
      }
    },

    splitMusicFile(file, fileList) {
      this.splitMusicAudio = file;
      this.splitUploadFileList = fileList;
    },

    async downloadSplitFile(event) {
      if (!this.splitMusicAudio || !this.splitMusicAudio.raw) {
        this.$message.warning("请先上传音频文件");
        return;
      }
      const { startTime, endTime } = event.timeRange;
      if (!startTime || !endTime) {
        this.$message.warning("请选择截取范围");
        return;
      }
      try {
        const res = await splitMusic(
          this.splitMusicAudio.raw,
          startTime,
          endTime,
          this.clientId
        );
        console.log("截取响应:", res);
        await downloadFile(res.data);
      } catch (error) {
        console.error("截取请求失败", error);
        this.$message.error("截取请求失败");
      }
    },

    videoMusicFile(file, fileList) {
      this.extractVideoFile = file.raw;
      this.splitUploadFileList = fileList;
      this.uploadFileName = file.name;
    },

    async extractVideoMusic() {
      if (!this.extractVideoFile) {
        this.$message.warning("请先上传视频文件");
        return;
      }
      try {
        const res = await extractVideoMusic(
          this.extractVideoFile,
          this.clientId
        );
        this.$message.success(res.data.message || "提取任务已提交");
        this.uploadFileChangeProgress = 0;
      } catch (error) {
        console.error("提取请求失败", error);
        this.$message.error("提取请求失败");
      }
    },

    videoSplitFile(file, fileList) {
      this.splitMusicAudio = file;
      this.splitUploadFileList = fileList;
      this.videoSrc = file;
    },

    async splitVideo() {
      if (!this.splitMusicAudio || !this.splitMusicAudio.raw) {
        this.$message.warning("请先上传视频文件");
        return;
      }
      const videoComp = this.$refs.videoComponent;
      if (!videoComp || !videoComp.getCutRange) {
        this.$message.warning("视频组件未准备好或无法获取时间范围");
        return;
      }
      const { start, end } = videoComp.getCutRange();
      if (!start || !end) {
        this.$message.warning("请选择截取范围");
        return;
      }
      try {
        const res = await splitVideo(
          this.splitMusicAudio.raw,
          start,
          end,
          this.clientId
        );
        console.log("视频截取响应:", res);
        if (res.data && res.data.code === 200) {
          const filePath = res.data.data;
          if (filePath) {
            this.downloadFileFromPath(filePath);
          } else {
            this.$message.error("返回的文件路径为空");
          }
        } else {
          this.$message.error(res.data?.message || "视频截取失败");
        }
      } catch (error) {
        console.error("视频截取请求失败", error);
        this.$message.error("视频截取请求失败");
      }
    },

    handleReset() {
      this.splitMusicAudio = null;
      this.splitUploadFileList = [];
      this.extractVideoFile = null;
      this.changeMusicFileObj = null;
      this.uploadFileName = "";
      this.uploadFileChangeProgress = 0;
      this.downloadUrl = "";
    },

    clear() {
      this.handleReset();
      this.target = "";
    },

    handleCancel() {
      this.clear();
    },

    downloadConvertedFile() {
      if (!this.downloadUrl) {
        this.$message.warning("文件尚未准备好");
        return;
      }
      this.downloadFileFromPath(this.downloadUrl);
    },

    async downloadFileFromPath(fileName) {
      await downloadFile(fileName);
    },
  },

  mounted() {
    this.clientId =
      Date.now().toLocaleString() + (Math.random() * 100).toString();
    console.log("clientId:", this.clientId);
    this.createSSE();
  },

  beforeDestroy() {
    if (this.sseConnection) {
      this.sseConnection.close();
    }
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

.clip-container {
  background-color: $help_back_color;
  border-radius: $main_border_radius;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  padding: 20px;

  .clip-header {
    background-color: #ffffff;
    padding: 20px;
    border-radius: $main_border_radius;
    display: flex;
    flex-direction: row;
    gap: 20px;

    .item {
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      display: flex;
      align-items: center;

      & > i:first-child {
        margin-right: 4px;
      }

      & > span {
        text-align: center;
      }
    }

    .active {
      color: #ffffff;
      background-color: $main_theme_color;
    }
  }

  .clip-content {
    margin-top: 20px;
    background-color: #ffffff;
    border-radius: $main_border_radius;
    flex: 1;
    padding: 20px;

    .change-music {
      .change-music-header {
        color: $help_font_color;
        display: flex;
        align-items: center;

        & > i:first-child {
          margin-right: 4px;
        }

        & > span {
          text-align: center;
          font-size: 14px;
          font-weight: bolder;
        }
      }

      .change-music-content {
        .change-music-content-target {
          margin-top: 20px;
          color: $help_font_color;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .change-music-content-file {
          margin-top: 40px;
          width: 100%;

          .upload {
            width: 100%;

            ::v-deep .el-upload {
              width: 100%;

              .el-upload-dragger {
                width: 100% !important;
                height: 280px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        .change-music-content-func {
          align-items: center;
          display: flex;
          justify-content: center;
          margin-top: 20px;
          gap: 20px;
        }
      }
    }

    .music-split {
      .music-split-header {
        color: $help_font_color;
        display: flex;
        align-items: center;

        & > i:first-child {
          margin-right: 4px;
        }

        & > span {
          text-align: center;
          font-size: 14px;
          font-weight: bolder;
        }
      }

      .music-split-content {
        .music-split-content-file {
          margin-top: 40px;
          width: 100%;

          .upload {
            width: 100%;

            ::v-deep .el-upload {
              width: 100%;

              .el-upload-dragger {
                width: 100% !important;
                height: 280px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }

    .video-music {
      .video-music-header {
        color: $help_font_color;
        display: flex;
        align-items: center;

        & > i:first-child {
          margin-right: 4px;
        }

        & > span {
          text-align: center;
          font-size: 14px;
          font-weight: bolder;
        }
      }

      .video-music-content {
        .video-music-content-file {
          margin-top: 40px;
          width: 100%;

          .upload {
            width: 100%;

            ::v-deep .el-upload {
              width: 100%;

              .el-upload-dragger {
                width: 100% !important;
                height: 280px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        .video-music-content-func {
          align-items: center;
          display: flex;
          justify-content: center;
          margin-top: 20px;
          gap: 20px;
        }
      }
    }

    .video-split {
      .video-split-header {
        color: $help_font_color;
        display: flex;
        align-items: center;

        & > i:first-child {
          margin-right: 4px;
        }

        & > span {
          text-align: center;
          font-size: 14px;
          font-weight: bolder;
        }
      }

      .video-split-content {
        .video-split-content-file {
          margin-top: 40px;
          width: 100%;

          .upload {
            width: 100%;

            ::v-deep .el-upload {
              width: 100%;

              .el-upload-dragger {
                width: 100% !important;
                height: 280px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }

  .upload-file-info {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 20px;

    .el-progress {
      flex: 1;
    }
  }
}
</style>
